import _ from 'lodash';

export default [
  '$window',
  '$q',
  '$interval',
  'AuthService',
  'ErrorHandler',
  'UserDataService',
  class FacebookLoginService {
    constructor($window, $q, $interval, authService, errorHandler, userData) {
      this._$window = $window;
      this._$q = $q;
      this._$interval = $interval;
      this._authService = authService;
      this._userData = userData;
      this._errorHandler = errorHandler;

      this.role = null;
      this.showPermissionsAlert = false;
      this.user = {
        status: null
      };
    }

    // allow login directive to handle errors
    login(authType) {
      return this._login(authType)
        .then(() => this._fetchPermissions())
        .then((res) => this._checkPermissions(res));
    }

    logout() {
      if (this.user.status === 'connected') {
        this._$window.FB.logout((res) => {
          this.user = res;
        });
      }
    }

    getLoggedInUser() {
      let defer = this._$q.defer();

      this._$interval.cancel(this.facebookInterval);
      this.facebookInterval = this._$interval(() => {
        if (this._$window.FB) {
          this._$interval.cancel(this.facebookInterval);
          this._$window.FB.getLoginStatus((res) => {
            this.user = res;
            if (res.status === 'connected') {
              defer.resolve(res);
            } else {
              defer.reject();
            }

            // TODO remove this
            // this._$window.FB.api('/me/permissions', 'delete');
            // this._$window.FB.logout((res) => {
            //   this.facebookUser = res;
            // });
            //end remove this
          });
        }
      }, 10);

      return defer.promise;
    }

    cancelAskForPermission() {
      this.showPermissionsAlert = false;
    }

    _login(authType) {
      let defer = this._$q.defer();

      this._$window.FB.login((res) => {
        this.user = res;
        if (res.authResponse) {
          defer.resolve(res);
        } else {
          defer.reject(res);
        }
      }, {
        scope: 'email',
        auth_type: authType || 'https'
      });

      return defer.promise;
    }

    _fetchPermissions() {
      let defer = this._$q.defer();

      this._$window.FB.api('/me/permissions', (res) => {
        if (!res.error) {
          defer.resolve(res.data);
        } else {
          defer.reject(res);
        }
      });

      return defer.promise;
    }

    _checkPermissions(res) {
      let defer = this._$q.defer();

      let emailPerm = _.find(res, (permission) => permission.permission === 'email');
      if (emailPerm.status !== 'granted') {
        this.showPermissionsAlert = true;
        defer.reject();
      } else {
        this.showPermissionsAlert = false;
        defer.resolve();
      }

      return defer.promise;
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/layout-components/account/facebook-auth/facebook-login-service.js